import { storage } from '../utils/storage';

const WS_URL =
  process.env.REACT_APP_WS_URL || 'wss://6idmkhd2q7.execute-api.us-east-1.amazonaws.com/dev';

class WebSocketService {
  constructor() {
    this.ws = null;
    this.listeners = {};
    this.restaurantId = null;
    this.reconnectTimeout = null;
    this.shouldReconnect = true;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 10;
  }

  connect(restaurantId = null) {
    // Si no se proporciona restaurantId, intentar obtenerlo del localStorage
    if (!restaurantId) {
      restaurantId = storage.get('selectedRestaurantId');
    }

    // Si aún no hay restaurantId, no conectar
    if (!restaurantId) {
      console.warn('No se puede conectar WebSocket: no hay restaurantId seleccionado');
      return;
    }

    // Si ya estamos conectados o conectando al mismo restaurante, no reconectar
    if (
      this.ws &&
      (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING) &&
      this.restaurantId === restaurantId
    ) {
      return;
    }

    // Si estamos conectados a un restaurante diferente, desconectar primero
    if (this.ws && this.restaurantId !== restaurantId) {
      this.shouldReconnect = false;
      this.disconnect();
      this.shouldReconnect = true;
    }

    this.restaurantId = restaurantId;
    const url = `${WS_URL}?restaurantId=${restaurantId}&clientType=admin`;
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      if (this.reconnectTimeout) {
        clearTimeout(this.reconnectTimeout);
        this.reconnectTimeout = null;
      }
      this.reconnectAttempts = 0;
      this.emit('CONNECTION_STATUS', { connected: true });
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        this.emit(data.type, data);
      } catch (parseError) {
        console.error('WebSocket: failed to parse message:', parseError);
      }
    };

    this.ws.onerror = (error) => {
      console.error('WebSocket connection error:', error);
      this.emit('CONNECTION_STATUS', { connected: false });
    };

    this.ws.onclose = () => {
      this.emit('CONNECTION_STATUS', { connected: false });
      if (this.shouldReconnect && this.restaurantId) {
        if (this.reconnectAttempts >= this.maxReconnectAttempts) {
          console.warn('WebSocket: max reconnect attempts reached');
          this.emit('CONNECTION_STATUS', { connected: false, maxRetriesReached: true });
          return;
        }
        const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 30000);
        this.reconnectAttempts++;
        this.reconnectTimeout = setTimeout(() => {
          this.connect(this.restaurantId);
        }, delay);
      }
    };
  }

  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  off(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter((cb) => cb !== callback);
    }
  }

  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach((callback) => callback(data));
    }
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }
}

const websocketService = new WebSocketService();
export default websocketService;
